import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import SectionDivider from '../../../components/SectionDivider.js';

import pages from './pages';

const useStyles = makeStyles({
  root: {
    padding: '1rem 0',
    width: '100%',
    height: '100%',
  },
});

const Menu = ({onClick, permissions, isSiteAdmin=false}) => {
  const classes = useStyles();
  const hasPermission = (permission) => isSiteAdmin || permissions.includes(permission);
  return (
    <div className={classes.root}>
      <List>
        {Object.entries(pages).map(([path, page]) => (
          (!page.permission || hasPermission(page.permission)) &&
            <React.Fragment key={path}>
              {page.divider &&  <SectionDivider />}
              <ListItem button onClick={() => onClick(path)}>
                <ListItemIcon>
                  {page.icon}
                </ListItemIcon>
                <ListItemText primary={page.label} />
              </ListItem>
            </React.Fragment>
        ))}
      </List>
    </div>
  );
};

Menu.propTypes = {
  onClick: PropTypes.func.isRequired,
  permissions: PropTypes.array,
  isSiteAdmin: PropTypes.bool,
};

export default Menu;
